
// import React, { useState,useRef } from 'react';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import { Button } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import PumpFormFields from './PumpFormFields';
// import ConfirmDialog from '../../../components/ConfirmDialog';
// import SuccessSnackbar from '../../../components/SuccessSnackbar';
// import FormContainerWrapper from '../../../components/FormContainerWrapper';
// import {useAuth} from '../../../AuthContext'

// // Validation schema using Yup
// const pumpSchema = Yup.object().shape({
//   name: Yup.string()
//     .min(2, 'Pump name must be at least 2 characters')
//     .max(50, 'Pump name must be less than 50 characters')
//     .required('Pump name is required'),
//   imei: Yup.string()
//     .matches(/^\d{15}$/, 'IMEI must be exactly 15 digits')
//     .required('IMEI is required'),
//   model_number: Yup.string()
//     .min(3, 'Model number must be at least 3 characters')
//     .required('Model number is required'),
//   serial_number: Yup.string()
//     .min(5, 'Serial number must be at least 5 characters')
//     .required('Serial number is required'),
//     manufacturer: Yup.string()
//     .min(5, 'Serial number must be at least 5 characters')
//     .required('Serial number is required'),
//   rating: Yup.number()
//     .min(0.1, 'Rating must be greater than 0')
//     .required('Rating is required'),
//   sim_iccid: Yup.string()
//     .matches(/^\d{19,20}$/, 'SIM ICCID must be 19 or 20 digits')
//     .required('SIM ICCID is required'),
// });

// // Styled components
// const SubmitButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(4),
//   padding: theme.spacing(1.5),
//   borderRadius: '10px',
//   backgroundColor: '#1976d2',
//   fontWeight: 'bold',
//   fontSize: '1rem',
//   '&:hover': {
//     backgroundColor: '#1565c0',
//   },
// }));

// const PumpCreation = () => {
//   const { createPump } = useAuth();
//   const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
//   const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
//   const [formValues, setFormValues] = useState(null);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('success')
//   const formikRef = useRef(null);
//   const handleSubmit = (values, { resetForm }) => {
//    // console.log('pump creation ke submit se values',values)
//     setFormValues(values);
//     setOpenConfirmDialog(true);
//     formikRef.current = resetForm;
 
//   };



  
//   // const handleConfirm = async () => {
//   //   if (!formValues) return;
//   //   try {
//   //    const response= await createPump(formValues);
//   //     setOpenConfirmDialog(false);
//   //     setOpenSuccessSnackbar(true);
//   //     setFormValues(null)
//   //     console.log('all of this ran')
//   //   } catch (error) {
//   //     console.log('ye error hai pump creation mein',error.message)
//   //     setErrorMessage(error.message);
//   //     setOpenSuccessSnackbar(true);
//   //     setOpenConfirmDialog(false);
//   //   }
//   // };

//   // const handleCloseSuccess = () => {
   
//   //   setOpenSuccessSnackbar(false);
//   //   setErrorMessage(null)
    
//   // };


//   const handleConfirm = async () => {
//     try {
//       if (!formValues) return;
      
//       await createPump(formValues);
      
//       // Clear form values before showing success
//       setFormValues(null);
//       setOpenConfirmDialog(false);
      
//       if (formikRef.current) {
//         console.log(formikRef.current.handleReset)
//         formikRef.current.handleReset()
//       }
//       // Set success message
//       setSnackbarMessage(`Pump ${formValues.name} Created Successfully!`);
//       setSnackbarSeverity('success');
      
//       setOpenSnackbar(true);
     
      
//     } catch (error) {
//       setOpenConfirmDialog(false);
      
//       // Clear form values on error too
//       setFormValues(null);
      
//       // Check if the error is from the API response
//       let errorMsg = "Failed to create Pump. Please try again. ";
//       console.log('error from pump creation in pump creation',error)
//       if (error.message.includes("Imei ")) {
       
//         errorMsg = "This IMEI  is already registered. Please check and enter valid IMEI ";
//        } 
//       else if (error.response) {
//         try {
//           const errorData = await error.response.json();
//           errorMsg = errorData.message || errorMsg;
//         } catch (e) {
//           console.error("Error parsing error response:", e);
//         }
//       }
      
//       setSnackbarMessage(errorMsg);
//       setSnackbarSeverity('error');
//       setOpenSnackbar(true);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//     // Don't clear message immediately to prevent flicker
//     setTimeout(() => {
//       setSnackbarMessage('');
//       setSnackbarSeverity('success');
//     }, 300);
//   };















//   return (
//     <FormContainerWrapper title="Add New Pump">
//       <Formik
//         initialValues={{
//           name: '',
//           imei: '',
//           model_number: '',
//           serial_number: '',
//           manufacturer:'',
//           rating: '',
//           sim_iccid: '',
//         }}
//         validationSchema={pumpSchema}
//         onSubmit={handleSubmit}
//         innerRef={formikRef} // Connect the ref to Formik

//       >
//         {({ errors, touched }) => (
//           <Form>
//             <PumpFormFields errors={errors} touched={touched} />
//             <SubmitButton type="submit" variant="contained" fullWidth>
//               Submit
//             </SubmitButton>
//           </Form>
//         )}
//       </Formik>

//       <ConfirmDialog
//         open={openConfirmDialog}
//         onClose={() => setOpenConfirmDialog(false)}
//         onConfirm={handleConfirm}
//         title="Confirm Pump Details"
//         content={
//           formValues && (
//             <div className="space-y-2">
//               <p><strong>Pump Name:</strong> {formValues.name}</p>
//               <p><strong>IMEI:</strong> {formValues.imei}</p>
//               <p><strong>Model Number:</strong> {formValues.model_number}</p>
//               <p><strong>Serial Number:</strong> {formValues.serial_number}</p>
//               <p><strong>Make:</strong> {formValues.manufacturer}</p>

//               <p><strong>Rating:</strong> {formValues.rating} HP</p>
//               <p><strong>SIM ICCID:</strong> {formValues.sim_iccid}</p>
//             </div>
//           )
//         }
//       />

// <SuccessSnackbar
//         open={openSnackbar}
//         onClose={handleCloseSnackbar}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         autoHideDuration={snackbarSeverity === 'error' ? 6000 : 3000}
//       />
//     </FormContainerWrapper>
//   );
// };

// export default PumpCreation;



// import React, { useState } from 'react';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import { Button, Typography } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import PumpFormFields from './PumpFormFields';
// import ConfirmDialog from '../../../components/ConfirmDialog';
// import SuccessSnackbar from '../../../components/SuccessSnackbar';
// import FormContainerWrapper from '../../../components/FormContainerWrapper';
// import { useAuth } from '../../../AuthContext';

// // Validation schema using Yup
// const pumpSchema = Yup.object().shape({
//   name: Yup.string()
//     .min(2, 'Pump name must be at least 2 characters')
//     .max(50, 'Pump name must be less than 50 characters')
//     .required('Pump name is required'),
//   imei: Yup.string()
//     .matches(/^\d{15}$/, 'IMEI must be exactly 15 digits')
//     .required('IMEI is required'),
//   model_number: Yup.string()
//     .min(3, 'Model number must be at least 3 characters')
//     .required('Model number is required'),
//   serial_number: Yup.string()
//     .min(5, 'Serial number must be at least 5 characters')
//     .required('Serial number is required'),
//   rating: Yup.number()
//     .min(0.1, 'Rating must be greater than 0')
//     .required('Rating is required'),
//   sim_iccid: Yup.string()
//     .matches(/^\d{19,20}$/, 'SIM ICCID must be 19 or 20 digits')
//     .required('SIM ICCID is required'),
// });

// // Styled components
// const SubmitButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(4),
//   padding: theme.spacing(1.5),
//   borderRadius: '10px',
//   backgroundColor: '#1976d2',
//   fontWeight: 'bold',
//   fontSize: '1rem',
//   '&:hover': {
//     backgroundColor: '#1565c0',
//   },
// }));

// const PumpCreation = () => {
//   const { createPump } = useAuth();
//   const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
//   const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
//   const [errorMessage, setErrorMessage] = useState('');
//   const [formValues, setFormValues] = useState(null);

//   const handleSubmit = (values) => {
//     console.log('pump creation ke submit se values', values);
//     setFormValues(values);
//     setErrorMessage(''); // Clear previous errors
//     setOpenConfirmDialog(true);
//   };

//   const handleConfirm = async () => {
//     if (!formValues) return;
//     try {
//       await createPump(formValues);
//       setOpenConfirmDialog(false);
//       setOpenSuccessSnackbar(true); // Only for success
//       setFormValues(null);
//     } catch (error) {
//       console.log('ye error hai pump creation mein', error.message);
//       const userFriendlyMessage =
//         error.message === 'imei already exists'
//           ? 'A pump with this IMEI already exists. Please use a different IMEI.'
//           : error.message || 'Failed to create pump. Please try again.';
//       setErrorMessage(error.message);
//       setOpenConfirmDialog(false);
//     }
//   };

//   const handleCloseSuccess = () => {
//     setOpenSuccessSnackbar(false);
//   };

//   const handleCloseError = () => {
//     setErrorMessage('');
//   };

//   return (
//     <FormContainerWrapper title="Add New Pump">
//       <Formik
//         initialValues={{
//           name: '',
//           imei: '',
//           model_number: '',
//           serial_number: '',
//           rating: '',
//           sim_iccid: '',
//         }}
//         validationSchema={pumpSchema}
//         onSubmit={handleSubmit}
//       >
//         {({ errors, touched }) => (
//           <Form>
//             <PumpFormFields errors={errors} touched={touched} />
//             {errorMessage && (
//               <Typography color="error" mt="10px" mb="10px">
//                 {errorMessage}
//               </Typography>
//             )}
//             <SubmitButton type="submit" variant="contained" fullWidth>
//               Submit
//             </SubmitButton>
//           </Form>
//         )}
//       </Formik>

//       <ConfirmDialog
//         open={openConfirmDialog}
//         onClose={() => setOpenConfirmDialog(false)}
//         onConfirm={handleConfirm}
//         title="Confirm Pump Details"
//         content={
//           formValues && (
//             <div className="space-y-2">
//               <p><strong>Pump Name:</strong> {formValues.name}</p>
//               <p><strong>IMEI:</strong> {formValues.imei}</p>
//               <p><strong>Model Number:</strong> {formValues.model_number}</p>
//               <p><strong>Serial Number:</strong> {formValues.serial_number}</p>
//               <p><strong>Rating:</strong> {formValues.rating} HP</p>
//               <p><strong>SIM ICCID:</strong> {formValues.sim_iccid}</p>
//             </div>
//           )
//         }
//       />

//       <SuccessSnackbar
//         open={openSuccessSnackbar}
//         onClose={handleCloseSuccess}
//         message="Pump Created Successfully!"
//         severity="success"
//       />
//     </FormContainerWrapper>
//   );
// };

// export default PumpCreation;






import React, { useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button, Typography, Box, Input } from '@mui/material';
import { styled } from '@mui/material/styles';
import PumpFormFields from './PumpFormFields';
import ConfirmDialog from '../../../components/ConfirmDialog';
import SuccessSnackbar from '../../../components/SuccessSnackbar';
import FormContainerWrapper from '../../../components/FormContainerWrapper';
import { useAuth } from '../../../AuthContext';

// Validation schema using Yup
const pumpSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Pump name must be at least 2 characters')
    .max(50, 'Pump name must be less than 50 characters')
    .required('Pump name is required'),
  imei: Yup.string()
    .matches(/^\d{15}$/, 'IMEI must be exactly 15 digits')
    .required('IMEI is required'),
  model_number: Yup.string()
    .min(3, 'Model number must be at least 3 characters')
    .required('Model number is required'),
  serial_number: Yup.string()
    .min(5, 'Serial number must be at least 5 characters')
    .required('Serial number is required'),
  manufacturer: Yup.string()
    .min(5, 'Manufacturer must be at least 5 characters')
    .required('Manufacturer is required'),
  rating: Yup.number()
    .min(0.1, 'Rating must be greater than 0')
    .required('Rating is required'),
    // panel_number_list: Yup.array()
    //     .of(Yup.string())
    //     .min(1, 'Please enter atleast one Panel No')
    //     .required('Panel number is required'),
    controller_number: Yup.string()
    .min(5, 'Controller number must be at least 5 characters')
    .required('Controller number is required'),     
  sim_iccid: Yup.string()
    .matches(/^\d{19,20}$/, 'SIM ICCID must be 19 or 20 digits')
    .required('SIM ICCID is required'),
});

// Styled components
const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(1.5),
  borderRadius: '10px',
  backgroundColor: '#1976d2',
  fontWeight: 'bold',
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: '#1565c0',
  },
}));

const UploadButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1.5),
  borderRadius: '10px',
  backgroundColor: '#388e3c',
  fontWeight: 'bold',
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: '#2e7d32',
  },
}));

const HiddenInput = styled(Input)({
  display: 'none',
});

const PumpCreation = () => {
  const { createPump, authorizedFetch } = useAuth();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [formValues, setFormValues] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const formikRef = useRef(null);
  const fileInputRef = useRef(null);

  // Handle single pump form submission
  const handleSubmit = (values, { resetForm }) => {
    setFormValues(values);
    setOpenConfirmDialog(true);
    formikRef.current = { handleReset: resetForm };
  };

  // Handle single pump confirmation
  const handleConfirm = async () => {
    try {
      if (!formValues) return;
      const result = await createPump(formValues);
      
      setFormValues(null);
      setOpenConfirmDialog(false);
      if (formikRef.current) {
        formikRef.current.handleReset();
      }
      
      // Check if pump was actually created
      if (result && (result.id || result.imei || result.success)) {
        setSnackbarMessage(`Pump ${formValues.name} Created Successfully!`);
        setSnackbarSeverity('success');
      } else {
        // Treat as warning if response is unclear
        setSnackbarMessage(`Pump creation submitted. Please verify in pump list.`);
        setSnackbarSeverity('warning');
      }
      setOpenSnackbar(true);
      
    } catch (error) {
      console.error('Error in handleConfirm:', error);
      setOpenConfirmDialog(false);
      
      // Don't clear form values if we're showing an actual error
      let errorMsg = 'Failed to create Pump. Please try again.';
      let isActualError = true;
      
      // Check for known error messages
      if (error.message && error.message.includes('Imei')) {
        errorMsg = 'This IMEI is already registered. Please check and enter valid IMEI';
      } 
      // Check if this might be a false error (pump was created despite error)
      else if (error.message && (error.message.includes('JSON') || error.message.includes('parse'))) {
        errorMsg = 'Pump may have been created. Please verify in pump list.';
        setSnackbarSeverity('warning');
        isActualError = false;
      }
      else if (error.response) {
        try {
          const errorData = await error.response.json();
          errorMsg = errorData.message || errorMsg;
        } catch (e) {
          console.error('Error parsing error response:', e);
          errorMsg = 'Pump may have been created. Please verify in pump list.';
          setSnackbarSeverity('warning');
          isActualError = false;
        }
      }
      
      if (isActualError) {
        setFormValues(null); // Only clear on actual errors
        setSnackbarSeverity('error');
      } else {
        setSnackbarSeverity('warning');
      }
      
      setSnackbarMessage(errorMsg);
      setOpenSnackbar(true);
    }
  };
 



const handleDownloadSample = async () => {
    const sampleCsvUrl = '/sample_upload.csv';
    try {
      const response = await authorizedFetch(sampleCsvUrl);
      if (!response.ok) {
        throw new Error('Sample CSV not found');
      }

      const contentType = response.headers.get('Content-Type') || '';

      if (!contentType.includes('text/csv')) {
      }

      const text = await response.text();
      // Basic validation of CSV content
      if (!text.startsWith('imei')) {
        throw new Error('Invalid sample CSV format');
      }

      const blob = new Blob([text], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'sample_upload.csv';
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Sample CSV download error:', error);
    //  Fallback: Generate sample CSV
      const csvContent = [
        'imei,rating,name,serial_number,model_number,sim_iccid,make,,controller_number',
        '123456789012345,5,Test Pump1,ABC123,ModelX,8901234567890123456,CompanyA,76897852354',
       
      ].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'sample_pump_upload.csv';
      a.click();
      URL.revokeObjectURL(url);

      setSnackbarMessage('Sample CSV downloaded (using fallback due to server issue).');
      setSnackbarSeverity('warning');
      setOpenSnackbar(true);
    }
  };






  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type and size
      if (!file.name.endsWith('.csv')) {
        setSnackbarMessage('Please select a CSV file.');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        return;
      }
      if (file.size > 5 * 1024 * 1024) { // 5MB limit
        setSnackbarMessage('File size exceeds 5MB limit.');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        return;
      }
      setSelectedFile(file);
    }
  };




  // Handle bulk CSV upload
  const handleBulkUpload = async () => {
    if (!selectedFile) {
      setSnackbarMessage('Please select a CSV file to upload.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', selectedFile);

      const response = await authorizedFetch(`/pump/bulk_upload`, {
        method: 'POST',
        body: formData,
      });
      

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to upload CSV file');
      }

      // Handle CSV response
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'bulk_upload_response.csv';
      a.click();
      URL.revokeObjectURL(url);

      setSnackbarMessage('Bulk upload successful! Response CSV downloaded.');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setSelectedFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Reset file input
      }
    } catch (error) {
      setSnackbarMessage(error.message || 'Failed to upload CSV file. Please try again.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  // Handle snackbar close
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setTimeout(() => {
      setSnackbarMessage('');
      setSnackbarSeverity('success');
    }, 300);
  };

  return (
    <FormContainerWrapper title="Add New Pump">
      <Formik
        initialValues={{
          name: '',
          imei: '',
          model_number: '',
          serial_number: '',
          manufacturer: '',
          rating: '',
            // panel_number_list:'',
          controller_number:'',
          sim_iccid: '',
        }}
        validationSchema={pumpSchema}
        onSubmit={handleSubmit}
        innerRef={formikRef}
      >
        {({ errors, touched }) => (
          <Form>
            <PumpFormFields errors={errors} touched={touched} />
            <SubmitButton type="submit" variant="contained" fullWidth>
              Submit
            </SubmitButton>
          </Form>
        )}
      </Formik>

      {/* Bulk Upload Section */}
      <Box sx={{ mt: 4, borderTop: '1px solid #ccc', pt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Bulk Upload Pumps via CSV
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <label htmlFor="csv-upload">
            <HiddenInput
              id="csv-upload"
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              inputRef={fileInputRef}
            />
            <Button
              variant="outlined"
              component="span"
              sx={{ borderRadius: '10px' }}
            >
              Choose CSV File
            </Button>
          </label>
              <Button
          variant="outlined"
          onClick={handleDownloadSample}
          sx={{ borderRadius: '10px' }}
        >
          Download Sample CSV
        </Button>
          {selectedFile && (
            <Typography variant="body2" color="textSecondary">
              Selected: {selectedFile.name}
            </Typography>
          )}
        </Box>
        <UploadButton
          variant="contained"
          fullWidth
          onClick={handleBulkUpload}
          disabled={!selectedFile}
        >
          Upload CSV
        </UploadButton>
        
      </Box>

      <ConfirmDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        onConfirm={handleConfirm}
        title="Confirm Pump Details"
        content={
          formValues && (
            <div className="space-y-2">
              <p><strong>Pump Name:</strong> {formValues.name}</p>
              <p><strong>IMEI:</strong> {formValues.imei}</p>
              <p><strong>Model Number:</strong> {formValues.model_number}</p>
              <p><strong>Serial Number:</strong> {formValues.serial_number}</p>
              <p><strong>Make:</strong> {formValues.manufacturer}</p>
              <p><strong>Rating:</strong> {formValues.rating} HP</p>
             {/* // <p><strong>Panel No:</strong> {formValues.panel_number_list?.join(', ') || 'None'}</p> */}
               <p><strong>Controller No:</strong> {formValues.controller_number}</p>
              <p><strong>SIM ICCID:</strong> {formValues.sim_iccid}</p>
            </div>
          )
        }
      />

      <SuccessSnackbar
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={snackbarSeverity === 'error' ? 6000 : 3000}
      />
    </FormContainerWrapper>
  );
};

export default PumpCreation;





//  <FormControl fullWidth margin="normal" error={touched.imei_list && !!errors.imei_list}>
//         <InputLabel 
//           shrink 
//           sx={{
//             fontSize: '1.2rem',
//             '&.Mui-focused': {
//               fontSize: '1.2rem',
//               color: '#1976d2',
//             },
//             marginTop:'-10px'
//           }}
//         >
//           Panel Number
//         </InputLabel>
//         {values.imei_list?.length > 0 ? (
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
//             <Chip
//               label={
//                 pumps.find(pump => pump.imei === values.imei_list[0])?.name
//                   ? `${values.imei_list[0]} - ${pumps.find(pump => pump.imei === values.imei_list[0]).name}`
//                   : values.imei_list[0]
//               }
//               onDelete={() => setFieldValue('imei_list', [])}
//               deleteIcon={<CancelIcon />}
//               sx={{ maxWidth: '80%' }}
//             />
//           </Box>
//         ) : (
//           <Select
//             multiple
//             value={values.imei_list || []}
//             onChange={(e) => setFieldValue('imei_list', [e.target.value[e.target.value.length - 1]])}
//             renderValue={(selected) => (
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                 {selected.map((imei) => (
//                   <Chip
//                     key={imei}
//                     label={imei}
//                     onDelete={() => setFieldValue('imei_list', [])}
//                     deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
//                   />
//                 ))}
//               </Box>
//             )}
//             MenuProps={{
//               PaperProps: {
//                 style: {
//                   maxHeight: 300,
//                 },
//               },
//             }}
//           >
//             <MenuItem value="" disabled>
//               Select a pump
//             </MenuItem>
//             {availablePumps.map((pump) => (
//               <MenuItem key={pump.imei} value={pump.imei}>
//                 {pump.imei} - {pump.name || 'Unnamed Pump'}
//               </MenuItem>
//             ))}
//           </Select>
//         )}
//         {touched.imei_list && errors.imei_list && (
//           <div style={{ color: '#f44336', fontSize: '0.75rem', margin: '3px 14px 0' }}>
//             {errors.imei_list}
//           </div>
//         )}
//       </FormControl>